module.exports = __webpack_public_path__ + "static/media/slay.fcade4ca.png";